import { activeOrganizationStorageKey } from './OrganizationContext';

const excluded = [
  '/health',
  '/identity/login',
  '/identity/logout',
  '/identity/session',
  '/identity/access',
  '/identity/organizations',
];
export function installInstitutionalFetch() {
  const original = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = new URL(
      input instanceof Request ? input.url : String(input),
      window.location.origin,
    );
    const organizationId = localStorage.getItem(activeOrganizationStorageKey);
    const needsContext =
      url.origin ===
        new URL(import.meta.env.VITE_URBANIK_API_URL ?? window.location.origin).origin &&
      !excluded.some((path) => url.pathname === path || url.pathname.startsWith(path));
    if (!needsContext || !organizationId) return original(input, init);
    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(init?.headers).forEach((value, key) => headers.set(key, value));
    headers.set('x-urbanik-organization', organizationId);
    return original(input, { ...init, headers });
  };
}
